export const useSxStyles = () => {
  return {
    dialogContentRoot: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
    spinner: {
      margin: 'auto',
    },
  };
};
